import { render, staticRenderFns } from "./PrkEducationGoals.vue?vue&type=template&id=4a780794&"
import script from "./PrkEducationGoals.vue?vue&type=script&lang=js&"
export * from "./PrkEducationGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports